"use strict";

define('view/calendar.view',['require','exports','module','marionette','uikit/uikit','view/table.card','libs/format/date','libs/format/bold','moment','templates','../langs'],function (require, exports, module) {
  var Mn = require('marionette');
  var UIKit = require('uikit/uikit');
  var TableCard = require('view/table.card');
  var DateFormat = require('libs/format/date');
  var BoldFormat = require('libs/format/bold');
  var moment = require('moment');
  var Templates = require('templates');
  var langs = require('../langs');
  var LIST_COLUMNS = [{
    text: 'Time',
    data: 'startDate',
    formatter: DateFormat('Do LT'),
    width: '20%'
  }, {
    text: 'Board',
    data: 'group.name',
    formatter: BoldFormat
  }, {
    text: 'Location',
    data: 'location',
    width: '30%'
  }];
  var EmptyModel = Backbone.Model.extend({});
  var Cards = Mn.CollectionView.extend({
    getChildView: function getChildView(model) {
      if (model instanceof EmptyModel) {
        return TableCard.Empty;
      }
      return TableCard;
    },
    childViewEventPrefix: 'card',
    childViewOptions: function childViewOptions() {
      return {
        headerSegmentColor: '',
        columns: this.getOption('columns')
      };
    }
  });
  var CalendarView = Mn.ItemView.extend(UIKit.ComponentMixin).extend({
    useInjector: true,
    template: Templates.IRB['calendar'],
    options: {
      listRangeLength: 5,
      useCalendarHeader: true,
      hideCalendarHeaderFromScreens: true,
      calendarHeaderText: ''
    },
    internalViews: {
      calendarList: Cards,
      calendarListControls: UIKit.Calendar.DefaultControlsView
    },
    internalViewOptions: {
      boardDropdown: {
        fluid: false,
        search: true,
        ariaLabel: langs.phrase('Meetings.Calendar.BoardDropdown.ARIALabel')
      },
      addMeeting: {
        text: 'New Meeting',
        icon: 'plus',
        color: 'primary',
        attributes: {
          role: 'button',
          'aria-label': "Add a new meeting"
        }
      },
      calendar: {
        fluid: true,
        verticalFluid: true,
        innercelled: true,
        size: "large",
        aligned: "right",
        selectable: true,
        appointmentList: true,
        controls: false
      },
      calendarWeek: {
        controls: false,
        borderless: true
      },
      calendarList: {
        columns: LIST_COLUMNS
      },
      calendarListControls: {
        size: 'huge',
        centered: true
      },
      calendarMenu: {
        dark: true,
        fluid: true,
        compact: true
      },
      todayButton: function todayButton() {
        var todayMoment = moment();
        return {
          text: 'Today',
          role: 'menuitem',
          ariaLabel: langs.phrase('Meetings.TodayButton.ARIALabel.Prefix') + todayMoment.format('MMMM D, YYYY')
        };
      },
      previousButton: {
        icon: 'chevron left',
        role: 'menuitem'
      },
      nextButton: {
        icon: 'chevron right',
        role: 'menuitem'
      },
      dimmer: {
        inverted: true
      }
    },
    ui: {
      bottomContainer: '.bottom-container',
      calendarListContainer: '.calendar-list-container',
      calendarContainer: '.calendar-container',
      calendarWeekContainer: '.calendar-week-container'
    },
    initialize: function initialize() {
      UIKit.ComponentMixin.initialize.apply(this, arguments);
      this.calendarListContainer = new UIKit.ItemView({
        template: false
      }).render();
      this.calendarContainer = new UIKit.ItemView({
        template: false
      }).render();
      this.calendarWeekContainer = new UIKit.ItemView({
        template: false
      }).render();
      this.setupCalendarMenu();
      this.setupDateText();
      this.setupPreviousNextButtons();
    },
    _setPrevNextButtonARIALabels: function _setPrevNextButtonARIALabels() {
      var previousMonthLabel = moment([this.calendar.year, this.calendar.month, 1]).subtract(1, 'months').format('MMMM YYYY');
      var nextMonthLabel = moment([this.calendar.year, this.calendar.month, 1]).add(1, 'months').format('MMMM YYYY');
      this.previousButton.$el.attr('aria-label', langs.phrase('Meetings.PrevNextButtons.ARIALabel.Prefix') + previousMonthLabel);
      this.nextButton.$el.attr('aria-label', langs.phrase('Meetings.PrevNextButtons.ARIALabel.Prefix') + nextMonthLabel);
    },
    setupPreviousNextButtons: function setupPreviousNextButtons() {
      var self = this;
      _.defer(function () {
        self._setPrevNextButtonARIALabels();
        self.listenTo(self.calendar.model, 'change:month', self._setPrevNextButtonARIALabels);
      });
    },
    setupDateText: function setupDateText() {
      var _updateDateText = _.debounce(this.updateDateText);
      this.calendar.on('change:month change:year', _updateDateText, this);
      this.calendarWeekContainer.on('change:visible', _updateDateText, this);
      this.calendarListContainer.on('change:visible', _updateDateText, this);
      this.calendarWeek.on('change:date', _updateDateText, this);
    },
    setupCalendarMenu: function setupCalendarMenu() {
      var menu = this.calendarMenu;
      menu.compact = true;
      menu.add(this.monthViewButton = new UIKit.Menu.Item({
        name: 'month',
        text: 'Month',
        link: true,
        attributes: {
          role: 'menuitem',
          'aria-label': langs.phrase('Meetings.CalendarMenu.MonthView.ARIALabel')
        }
      }));
      menu.add(this.weekViewButton = new UIKit.Menu.Item({
        name: 'week',
        text: 'Week',
        link: true,
        attributes: {
          role: 'menuitem',
          'aria-label': langs.phrase('Meetings.CalendarMenu.WeekView.ARIALabel')
        }
      }));
      menu.add(this.listViewButton = new UIKit.Menu.Item({
        name: 'list',
        text: 'List',
        link: true,
        attributes: {
          role: 'menuitem',
          'aria-label': langs.phrase('Meetings.CalendarMenu.ListView.ARIALabel')
        }
      }));
    },
    onRender: function onRender() {
      this.calendarListContainer.setElement(this.ui.calendarListContainer);
      this.calendarContainer.setElement(this.ui.calendarContainer);
      this.calendarWeekContainer.setElement(this.ui.calendarWeekContainer);
    },
    updateDateText: function updateDateText() {
      if (this.calendarWeekContainer.visible) {
        var date = moment(this.calendarWeek.date).startOf('week');
        this.dateText.text = 'Week of ' + date.format('MMMM DD, YYYY');
      } else if (this.calendarListContainer.visible) {
        var date = moment([this.calendar.year, this.calendar.month, 1]),
          endDate = date.clone().add(this.getOption('listRangeLength'), 'month');
        this.dateText.text = date.format('MMM YYYY') + ' - ' + endDate.format('MMM YYYY');
      } else {
        var date = moment([this.calendar.year, this.calendar.month, 1]);
        this.dateText.text = date.format('MMMM YYYY');
      }
    }
  });
  CalendarView.EmptyModel = EmptyModel;
  module.exports = CalendarView;
});

